import camelcase from "camelcase"
import { appKey } from "@config"

const __ENV__ = process.env.NODE_ENV
const ENABLE = true
const token = "3586a4df558173fe"
const siteName = camelcase(appKey)

const sensors =
  typeof window !== "undefined" ? require("sa-sdk-javascript") : null

if (ENABLE && sensors) {
  sensors.init({
    sdk_url:
      "https://cdn.jsdelivr.net/npm/sa-sdk-javascript@1.14.14/sensorsdata.min.js",
    name: "sensors",
    server_url: `https://jihe.datasink.sensorsdata.cn/sa?token=${token}${
      __ENV__ === "production" ? "&project=production" : ""
    }`,
    is_track_single_page: false, // 不执行默认 pageView
    show_log: __ENV__ !== "production",
    heatmap: {
      // 是否开启点击图，默认为 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
      // 需要 JSSDK 版本号大于 1.7
      clickmap: "not_collect",
      // 是否开启触达注意力图，默认为 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
      // 需要 JSSDK 版本号大于 1.9.1
      scroll_notice_map: "not_collect",
    },
  })

  sensors.registerPage({
    platform: "h5",
    site_name: siteName,
  })
}

const sensorsSource = (source) =>
  source ? `h5.${siteName}.${source}` : `h5.${siteName}.unknown`

export const pageView = (screenName, isLoadingFirstPage = false) => {
  if (!ENABLE) {
    return
  }
  const options = screenName && { screenName: sensorsSource(screenName) }
  if (isLoadingFirstPage) {
    sensors.quick("autoTrack", options)
  } else {
    sensors.quick("autoTrackSinglePage", options)
  }
}

// 下面写事件

export const trackShare = () => {
  sensors.track("H5Annual2021Share")
}
export const trackHasData = (type) => {
  sensors.track("H5Annual2021HasData", { data_type: type })
}
